import list from "@/pages/customerCar/list";
import add from "@/pages/customerCar/add";
import edit from "@/pages/customerCar/edit";
import listReport from "@/pages/customerCar/listForReport";
import allCarList from "@/pages/customerCar/allCustomerCarList";
const routes = [
  {
    path: "/CustomerCar/List/:id",
    component: list,
    meta: {requiredAuth: true},
  },
  {
    path: "/CustomerCar/add/:id",
    component: add,
    meta: {requiredAuth: true},
  },
  {
    path: "/CustomerCar/Edit/:id",
    component: edit,
    meta: {requiredAuth: true},
  },
  {
    path: "/CustomerCar/listReport",
    component: listReport,
    meta: {requiredAuth: true},
  },
  {
    path: "/CustomerCars/List",
    component: allCarList,
    meta: {requiredAuth: true},
  }
]

export default routes;